import { createFileRoute } from '@tanstack/react-router';
import { AccountSettingsPage } from '@/features/account/AccountSettingsPage';

export const Route = createFileRoute('/account/details')({
  component: RouteComponent,
});

function RouteComponent() {
  return <AccountSettingsPage />;
}
